<template>
    <div class="condition-box">
        <div style="">
            <div class="title-box">
                <span>条件名称</span>
                <input v-model="branchName" type="text" class="itemInput" style="flex:1;">
            </div>
            <el-radio-group v-model="branchType" @change="conditionsTypeChange" size="medium"
                            style="margin:20px 0 20px 20px;">
                <el-radio v-for="(item,i) in radioList" :key="i" :label="item.value" style="font-size:16px;">
                    {{item.name}}
                </el-radio>
            </el-radio-group>
        </div>
        <div style="padding:0 20px 20px;">
            <div v-if="branchType == 1" class="item-box flex-box">
                <p>申请人</p>
                <p>等于</p>
                <p>部门负责人</p>
            </div>
            <div v-if="branchType == 4" class="item-box flex-box">
                <p>员工</p>
                <p>等于</p><input class="itemInput" v-model="staffName " placeholder=""
                                @focus="handleClickExpressionVisible"
                                readonly>
            </div>
            <div v-if="branchType == 2" class="item-box flex-box">
                <p>部门</p>
                <p>等于</p><input class="itemInput" v-model="staffName " placeholder=""
                                @focus="handleClickExpressionVisible"
                                readonly>
            </div>
            <div v-if="branchType == 3" class="item-box flex-box">
                <p>岗位</p>
                <p>等于</p><input class="itemInput" v-model="staffName " placeholder=""
                                @focus="handleClickExpressionVisible"
                                readonly>
            </div>
            <div v-if="branchType == 23">
                <div v-for="(item,index) in customConditions" :key="'custom' + index" class="item-box">
                    <div style="flex: 0 0 30%;">
                        <el-select v-model="item.fieldName" placeholder="请选择" size="30%"
                                   @change="onSelectedOpt(item.fieldName,index)">
                            <el-option v-for="(opt,i) in customFormFieldOptions" :key="opt.fieldName" :label="opt.text"
                                       :value="opt.fieldName">
                            </el-option>
                        </el-select>
                    </div>
                    <div style="flex: 0 0 20%;">
                        <el-select v-model="item.compareType" placeholder="请选择" size="15%">
                            <template v-if="item.fieldStyle == 'dropdownlist'">
                                <el-option label="包含" value="包含"></el-option>
                            </template>
                            <template v-else-if="item.fieldStyle == 'textbox'">
                                <template v-if="item.fieldDataType=='string'">
                                    <el-option label="等于" value="等于"></el-option>
                                </template>
                                <template v-else>
                                    <el-option label="等于" value="等于"></el-option>
                                    <el-option label="大于" value="大于"></el-option>
                                    <el-option label="小于" value="小于"></el-option>
                                    <el-option label="大于等于" value="大于等于"></el-option>
                                    <el-option label="小于等于" value="小于等于"></el-option>
                                </template>
                            </template>
                            <template v-else-if="item.fieldStyle == 'datepicker'">
                                <el-option label="等于" value="等于"></el-option>
                                <el-option label="大于" value="大于"></el-option>
                                <el-option label="小于" value="小于"></el-option>
                                <el-option label="大于等于" value="大于等于"></el-option>
                                <el-option label="小于等于" value="小于等于"></el-option>
                            </template>
                        </el-select>
                    </div>
                    <div style="flex: 0 0 30%;">
                        <template v-if="item.fieldStyle == 'dropdownlist'">
                            <input v-model="item.value" type="text" class="itemInput"
                                   @focus="handleClickDictVisible(index,item)">
                        </template>
                        <template v-else-if="item.fieldStyle == 'textbox'">
                            <input v-model="item.value" type="text" class="itemInput">
                        </template>
                        <template v-else-if="item.fieldStyle == 'datepicker'">
                            <el-date-picker
                                    v-model="item.value"
                                    type="date"
                                    placeholder="选择日期"
                                    value-format="yyyy-MM-dd">
                            </el-date-picker>
                        </template>
                        <template v-else><input type="text" class="itemInput" readonly></template>
                    </div>
                    <i class="el-icon-delete" style="font-size:20px;" @click="delItem(index)"></i>
                </div>
                <el-button type="primary" icon="el-icon-plus" @click="addCondition" style="margin-top:20px;">添加条件
                </el-button>
            </div>
            <div class="dialog-footer">
                <el-button @click="cancelSaveBranch" size="small">取 消</el-button>
                <el-button type="primary" @click="handleClickSaveBranch" size="small">确 定</el-button>
            </div>
        </div>
        <div v-if="dialogExpressionVisible">
            <el-dialog title="选择" :visible.sync="dialogExpressionVisible" :append-to-body="true" width="800px">
                <div v-if="branchType == 4">
                    <checkbox-list :data-source="usersOptions" :checked-items="conditionJson"
                                   @onchecked="handleCheckListChecked"
                                   :key="'4'"></checkbox-list>
                </div>
                <div v-if="branchType == 2">
                    <el-tree :data="treeData" show-checkbox default-expand-all node-key="id" ref="tree"
                             highlight-current :props="defaultProps"
                             :default-checked-keys="conditionJson"></el-tree>
                </div>
                <div v-if="branchType == 3">
                    <checkbox-list :data-source="postOptions" :checked-items="conditionJson"
                                   @onchecked="handleCheckListChecked"
                                   :key="'3'"></checkbox-list>
                </div>
                <div class="dialog-footer" style="text-align: right;">
                    <el-button @click="dialogExpressionVisible = false" size="small">取 消</el-button>
                    <el-button type="primary" @click="handleClickSaveExpression" size="small">确 定</el-button>
                </div>
            </el-dialog>
        </div>
        <div>
            <el-dialog title="选择" :visible.sync="dialogDictVisible" :append-to-body="true" width="800px">
                <checkbox-list :data-source="dictOptions" :checked-items="checkedDicts.map(item => item.uuid)"
                               @onchecked="handleDictChecked"
                               :key="'23'"></checkbox-list>
                <div class="dialog-footer" style="text-align: right;">
                    <el-button @click="dialogDictVisible = false" size="small">取 消</el-button>
                    <el-button type="primary" @click="handleClickSaveDict" size="small">确 定</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import CheckboxList from "./CheckboxList";
    import userService from "../service/flowChart/userService";
    import postService from "../service/flowChart/postService";
    import departmentService from "../service/flowChart/departmentService";
    import workflowService from "../service/flowChart/workflowService";
    import dictService from "../service/flowChart/dictService";

    export default {
        components: {
            CheckboxList,
        },
        props: {
            transition: {
                type: Object,
                default: null,
            },
        },
        data() {
            return {
                branchName: this.transition.defaultName,
                conditionJson : this.transition.defaultConditionjson,
                description : this.transition.defaultDescription ,
                branchType: this.transition.defaultType,
                defaultProps: {children: 'children', label: 'text'},
                treeData: [],
                radioList: [{
                    name: "申请人",
                    value: 1
                }, {
                    name: "员工",
                    value: 4
                }, {
                    name: "部门",
                    value: 2
                }, {
                    name: "岗位",
                    value: 3
                }, {
                    name: "自定义条件",
                    value: 23
                }],
                staffName: '',
                checkedItems: [],
                clickIndex: '',
                checkedDepartments: [],
                dialogExpressionVisible: false,
                dialogDictVisible: false,
                usersOptions: [],
                postOptions: [],
                customConditions: [],
                checkedDicts: [],
                dictOptions: [],
                customFormFieldOptions: [],
                customFlowConditioncSql: ''
            };
        },
        watch: {

        },
        async mounted() {
            // if (this.branchType == '23') {
            //     this.customConditions = this.transition.defaultConditionjson;
            // }else {
            //     if(this.transition.defaultDescription && this.transition.defaultDescription.length > 0){
            //         this.staffName = this.transition.defaultDescription;
            //     }
            // }
            let workflowResp = await workflowService.getFormFields(this.$route.query.id || 1);
            if (workflowResp.data.Status === "1") {
                this.customFormFieldOptions = workflowResp.data.Data;
            }
            let userResp = await userService.getUserOptions();
            if (userResp.data.Status === "1") {
                this.usersOptions = userResp.data.Data;
                if (this.branchType == '4') {
                    let userTexts = [];
                    this.usersOptions.forEach((obj, i) => {
                        this.transition.defaultConditionjson.forEach((uuid, j) => {
                            if (obj.uuid == uuid) {
                                userTexts.push(obj.name)
                            }
                        })
                    })
                    this.staffName = userTexts.join(',');
                }
            }
            let postResp = await postService.getRoleOptions();
            if (postResp.data.Status === "1") {
                this.postOptions = postResp.data.Data;
                if (this.branchType == '3') {
                    let postTexts = [];
                    this.postOptions.forEach((obj, i) => {
                        this.transition.defaultConditionjson.forEach((uuid, j) => {
                            if (obj.uuid == uuid) {
                                postTexts.push(obj.name)
                            }
                        })
                    })
                    this.staffName = postTexts.join(',');
                }
            }
            let treeResp = await departmentService.getTreeData();
            if (treeResp.data) {
                this.treeData = treeResp.data;
                if (this.branchType == '2') {
                    this.staffName = this.checkedDepartmentsText(this.treeData,this.transition.defaultConditionjson);
                }
            }

        },
        computed: {},
        methods: {
            checkedDepartmentsText: function(treeData,checkedDepartmentIds) {
                let nodes = [];
                let findCheckedTreeText = node => {
                    node.forEach((obj, i) => {
                        if (checkedDepartmentIds.indexOf(obj.id) != -1) {
                            nodes.push(obj.text)
                        }
                        if (obj.children && obj.children.length > 0) {
                            findCheckedTreeText(obj.children)
                        }
                    })
                };
                findCheckedTreeText(treeData);
                return nodes
            },
            addCondition() {
                this.customConditions.push({});
            },
            delItem(index) {
                this.customConditions.splice(index, 1);
            },
            onSelectedOpt(val, index) {
                let obj = {};
                obj = this.customFormFieldOptions.find((item) => {
                    return item.fieldName === val;
                });
                this.customConditions[index].fieldStyle = obj.fieldStyle;
                this.customConditions[index].text = obj.text;
                this.customConditions[index].fieldDataType = obj.fieldDataType;
                this.customConditions[index].dictionaryName = obj.dictionaryName;
                if (this.customConditions[index].compareType !== undefined) {
                    this.customConditions[index].compareType = "";
                }
                if (this.customConditions[index].value !== undefined) {
                    this.customConditions[index].value = "";
                }

            },
            handleClickExpressionVisible() {
                this.dialogExpressionVisible = true;
            },
            async handleClickDictVisible(index, item) {
                this.checkedDicts = [];
                this.dialogDictVisible = true;
                this.clickIndex = index;
                let dictResp = await dictService.getDictOptions(item.dictionaryName);
                if (dictResp.data.Status === "1") {
                    this.dictOptions = dictResp.data.Data;
                }
                if (item.uuid) {
                    let checkedArr = item.uuid.split(',');
                    checkedArr.forEach((val, i) => {
                        var obj = {};
                        obj.uuid = val;
                        this.checkedDicts.push(obj);
                    })
                }
            },
            handleClickSaveExpression() {
                this.dialogExpressionVisible = false;
                if (this.branchType == 4) {
                    this.description  = '员工等于' + this.checkedItems.map(item => item.name).join(",");
                    this.conditionJson  = this.checkedItems.map(item => item.uuid);
                    this.staffName = this.checkedItems.map(item => item.name).join(",");
                }
                if (this.branchType == 3) {
                    this.description  = '岗位等于' + this.checkedItems.map(item => item.name).join(",");
                    this.conditionJson  = this.checkedItems.map(item => item.uuid);
                    this.staffName = this.checkedItems.map(item => item.name).join(",");
                }
                if (this.branchType == 2) {
                    this.description  = '部门等于' + this.$refs.tree.getCheckedNodes().map(item => item.text).join(",");
                    this.conditionJson  = this.$refs.tree.getCheckedNodes().map(item => item.id);
                    this.staffName = this.$refs.tree.getCheckedNodes().map(item => item.text).join(",");
                }
            },
            handleClickSaveDict() {
                this.dialogDictVisible = false;
                this.customConditions[this.clickIndex].uuid = this.checkedDicts.map(item => item.uuid).join(",");
                this.customConditions[this.clickIndex].value = this.checkedDicts.map(item => item.name).join(",");
            },
            cancelSaveBranch() {
                this.$emit('onclosebranchvisible', {});
            },
            saveCustomFlowCondition() {
                var customWorkflowSql = '';
                this.customConditions.forEach((obj, i) => {
                    var sql = '';
                    switch (obj.fieldStyle) {
                        case 'dropdownlist':
                            sql += ' find_in_set('+obj.fieldName+',"'+obj.uuid+'")> 0';
                            break;
                        case 'textbox':
                            if(obj.fieldDataType=="string") {
                                sql += ""+obj.fieldName+" ='"+obj.value+"'";
                            }else{
                                if(obj.compareType == "等于") {
                                    sql += ""+obj.fieldName+"='"+obj.value+"'";
                                }else if(obj.compareType=="大于") {
                                    sql += ""+obj.fieldName+">'"+obj.value+"'";
                                }else if(obj.compareType=="小于") {
                                    sql += ""+obj.fieldName+"<'"+obj.value+"'";
                                }else if(obj.compareType=="大于等于") {
                                    sql += ""+obj.fieldName+">='"+obj.value+"'";
                                }else if(obj.compareType=="小于等于") {
                                    sql += ""+obj.fieldName+"<='"+obj.value+"'";
                                }
                            }
                            break;
                        case 'datepicker':
                            if(obj.compareType == "等于") {
                                sql += ""+obj.fieldName+"='"+obj.value+"'";
                            }else if(obj.compareType=="大于") {
                                sql += ""+obj.fieldName+">'"+obj.value+"'";
                            }else if(obj.compareType=="小于") {
                                sql += ""+obj.fieldName+"<'"+obj.value+"'";
                            }else if(obj.compareType=="大于等于") {
                                sql += ""+obj.fieldName+">='"+obj.value+"'";
                            }else if(obj.compareType=="小于等于") {
                                sql += ""+obj.fieldName+"<='"+obj.value+"'";
                            }
                            break;
                        default:
                    }
                    if(i < this.customConditions.length-1) {
                        sql +=" and ";
                    }
                    customWorkflowSql+=sql;
                })
                return customWorkflowSql
            },
            handleClickSaveBranch() {
                if (this.branchType == 23) {
                    this.description  = this.customConditions[0].text + this.customConditions[0].compareType + this.customConditions[0].value;
                    this.conditionJson  = [this.customConditions];
                    this.customFlowConditioncSql = this.saveCustomFlowCondition();
                }
                this.$emit('onchangebranch', {
                    conditionType: this.branchType,
                    name: this.branchName,
                    description: this.description ,
                    conditionJson: this.conditionJson ,
                    title: this.customFlowConditioncSql
                });
            },
            conditionsTypeChange() {
                if (this.branchType == 1) {
                    this.description  = '申请人等于部门负责人';
                    this.conditionJson  = [];
                } else {
                    this.description  = '';
                    this.staffName = '';
                    this.conditionJson  = [];

                }
                this.customConditions = [];

            },
            handleCheckListChecked(obj) {
                this.checkedItems = obj.checkedOptions;
            },
            handleDictChecked(obj) {
                this.checkedDicts = obj.checkedOptions;
            }
        },
    }
</script>

<style>
    .condition-box .el-radio__label {
        font-size: 16px;
    }

    .title-box {
        font-size: 16px;
        color: #000;
        padding: 15px 20px;
        border-bottom: 1px solid #DCDFE6;
        display: flex;
        align-items: center;
    }

    .title-box > span {
        margin-right: 10px;
    }

    .item-box {
        display: flex;
        justify-content: space-around;
        align-items: center;
        font-size: 14px;
        margin-bottom: 10px;
    }

    .flex-box > p {
        flex: 0 0 30%;
        border-radius: 4px;
        border: 1px solid #DCDFE6;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        color: #606266;
        font-size: 14px;
        height: 40px;
        line-height: 40px;
        padding: 0 15px;
        margin: 0;
    }

    .flex-box > p:nth-child(2) {
        flex: 0 0 20%;
    }

    .flex-box > input {
        flex: 0 0 30%;
    }

    .el-date-editor.el-input, .el-date-editor.el-input__inner {
        width: 186px;
    }

    .itemInput {
        webkit-appearance: none;
        background-color: #FFF;
        background-image: none;
        border-radius: 4px;
        border: 1px solid #DCDFE6;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        color: #606266;
        display: inline-block;
        font-size: 14px;
        height: 40px;
        line-height: 40px;
        outline: 0;
        padding: 0 15px;
        -webkit-transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
        transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
        width: auto;
        cursor: pointer;
    }
</style>
